<template>
    <div>
        <v-dialog 
            v-model="$store.getters.overlays.programAdminQuickAccess" 
            max-width="1000"
            :fullscreen="$store.getters.window.width<=600"
            content-class="programAdminQuickAccess"
            >


            <div :class="$style.quickAccessWrapper">
                <v-icon
                    @click="closeQuickAccess"
                    :class="$style.closeQuickAccessDialog"
                    color="black"
                    dark
                >
                    fas fa-times-circle
                </v-icon>
                
                <p :class="$style.quickAccessTitle">
                    Quick Access to Program Information
                </p>

                <div :class="$style.quickAccessContentWrapper">
                    <div :class="$style.quickAccessContentInnerWrapper">
                        <div 
                            :class="$style.quickAccessContent"
                            @click="accessProgramEditor('general')">
                            <v-icon color="white">
                                fas fa-info-circle
                            </v-icon>
                            <span class='ml-3'>General Info</span>
                        </div>
                    </div>

                    <div :class="$style.quickAccessContentInnerWrapper">
                        <div 
                            :class="$style.quickAccessContent"
                            @click="accessProgramEditor('card')">
                            <v-icon color="white">
                                fas fa-info-circle
                            </v-icon>
                            <span class='ml-3'>Program Card</span>
                        </div>
                    </div>
                    <div :class="$style.quickAccessContentInnerWrapper">
                        <div 
                            :class="$style.quickAccessContent"
                            @click="accessProgramEditor('overview')">
                            <v-icon color="white">
                                fas fa-info-circle
                            </v-icon>
                            <span class='ml-3'>Overview</span>
                        </div>
                    </div>

                    <div :class="$style.quickAccessContentInnerWrapper">
                        <div 
                            :class="$style.quickAccessContent"
                            @click="accessProgramEditor('faculty')">
                            <v-icon color="white">
                                fas fa-users
                            </v-icon>
                            <span class='ml-3'>Faculty</span>
                        </div>
                    </div>

                    <div :class="$style.quickAccessContentInnerWrapper">
                        <div 
                            :class="$style.quickAccessContent"
                            @click="accessProgramEditor('objective')">
                            <v-icon color="white">
                                fas fa-bullseye
                            </v-icon>
                            <span class='ml-3'>Objectives</span>
                        </div>
                    </div>

                    <div :class="$style.quickAccessContentInnerWrapper">
                        <div 
                            :class="$style.quickAccessContent"
                            @click="accessProgramEditor('pic')">
                            <v-icon color="white">
                                fas fa-balance-scale
                            </v-icon>
                            <span class='ml-3'>Pt Inclusion Criteria</span>
                        </div>
                    </div>

                    <div :class="$style.quickAccessContentInnerWrapper">
                        <div 
                            :class="$style.quickAccessContent"
                            @click="accessProgramEditor('flow')">
                            <span class='ml-3'>Step Flows</span>
                        </div>
                    </div>
                </div>
            </div>  

        </v-dialog>
    </div>
</template>

<script>
export default {
    name : "ProgramAdminQuickAccess",
    data: function() {
        return {
            editingProgram : null,
            editingProgramId: 0,
            controller: null
        }
    },
    created: function(){
        this.init();
    },
    methods: {
        init: function(){
            var self = this;
            self.controller = new this.source(self);
            self.$controller.programAdminQuickAccess = self.controller;     
        },
        closeQuickAccess: function() {
            this.$controller.programAdminQuickAccess.close();
        },
        source: function(self){
            this.open = function(program=null){
                self.editingProgram = program;
                self.editingProgramId = program.id;
                self.$store.dispatch('programAdminQuickAccess',true);
            }

            this.close = function(){
                self.$store.dispatch('programAdminQuickAccess',false);
            }
        },
        accessProgramEditor: function(action) {
            this.$router.push(`/admin/program/${this.editingProgramId}/${action}`);
            this.closeQuickAccess();
        }
    }
}
</script>

<style module>
.quickAccessWrapper {
    position: relative;
    background-color: white;
}

.closeQuickAccessDialog {
    position: absolute;
    top: 10px;
    right: 10px;
}

.quickAccessTitle {
    font-size: 1.2rem;
    width: 100%;
    text-align: center;
    color: black;
    padding-top: 20px;
}

.quickAccessContentWrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px 0;
}

.quickAccessContentInnerWrapper {
    width: 25%;
}

.quickAccessContent {
    border-radius: 5px;
    background-color: #3aacc4;
    color: white;
    width: 200px;
    height: 40px;
    font-size: 0.9rem;
    text-align: center;
    margin: 20px auto;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
</style>

<style>
.programAdminQuickAccess {
    border-radius: 5px;
}
</style>